<form [formGroup]="form" class="form" *ngIf="form">
</form>
